import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

import CartItemLayoutNew from '../CartItemLayoutNew'

export const CartProductBlock = styled(CartItemLayoutNew)`
  background: ${({ theme }) => theme.colors.white};

  ${p => p.theme.mq.upLg} {
    margin-bottom: 0;
    margin-top: 0;
    min-height: ${em(120)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  width: ${em(50)};
  height: auto;
  position: absolute;

  ${p => p.theme.mq.upMd} {
    position: relative;
    display: inline-block;
    width: ${em(103)};
  }

  ${p => p.theme.mq.upLg} {
    display: block;
    width: ${em(103)};
    padding-right: ${em(7)};
    margin-top: ${em(2)};
    margin-left: auto;
  }
`

export const CostBlock = styled.div`
  text-align: right;
  line-height: 0;

  ${p => p.theme.mq.upMd} {
    text-align: left;
  }
`
